<template>
  <v-card>
    <v-card-text>
      <v-container fluid>
        <v-row class="pa-4" justify="space-between">
          <v-col cols="4">
            <v-card>
              <v-toolbar dense flat color="primary" dark>
                <v-toolbar-title>渠道管理</v-toolbar-title>
              </v-toolbar>
              <v-treeview
                  hoverable
                  activatable
                  transition
                  return-object
                  item-key="name"
                  item-text="name"
                  :items="countries"
                  :load-children="getNext"
                  :active.sync="actives"
              >
                <template v-slot:prepend="{ item }">
                  <v-icon v-if="item.type === 'country'">
                    mdi-earth
                  </v-icon>
                  <v-icon v-else-if="item.type === 'channel'">
                    mdi-crosshairs-gps
                  </v-icon>
                  <v-icon v-else-if="item.type === 'channelType'">
                    mdi-home-map-marker
                  </v-icon>
                  <v-icon v-else-if="item.type === 'repository'">
                    mdi-home-city
                  </v-icon>
                  <v-icon v-else-if="item.type === 'limit' && item.priceType === 1">
                    mdi-weight-kilogram
                  </v-icon>
                  <v-icon v-else-if="item.type === 'limit' && item.priceType === 2">
                    mdi-camera-metering-matrix
                  </v-icon>
                </template>
              </v-treeview>
              <v-divider/>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" small><v-icon small>mdi-plus</v-icon>新增渠道</v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-divider vertical></v-divider>

          <v-col>
            <provider-card v-if="selected.type === 'channel'" :key="selected.name" :channel="selected"/>
            <channel-detail-card v-else-if="selected.type === 'country'" :key="selected.name" :channel="selected"/>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import ProviderCard from "@/page/Provider/ProviderCard";
import ChannelDetailCard from "@/page/Provider/ChannelDetailCard";
export default {
  name: "ProviderManager",
  components: {ChannelDetailCard, ProviderCard},
  computed: {
    selected () {
      return this.actives.length ? this.actives[0] : {}
    },
  },
  data: () => ({
    actives: [],
    countries: [
      {
        type: 'country',
        name: '美国',
        children: []
      },
      {
        type: 'country',
        name: '日本',
        children: []
      },
      {
        type: 'country',
        name: '欧洲',
        children: []
      },
      {
        type: 'country',
        name: '英国',
        children: []
      },
      {
        type: 'country',
        name: '加拿大',
        children: []
      }
    ]
  }),
  methods: {
    getNext(item) {
      console.log(item.name)
      if (item.type === 'country') {
        return this.getChannels(item)
      } else if (item.type === 'channel') {
        return this.getChannelTypes(item)
      } else if (item.type === 'channelType') {
        return this.getRepositories(item)
      } else if (item.type === 'repository') {
        return this.getLimits(item)
      }
    },
    getChannels(item) {
      return new Promise((resolve, reject) => {
        this.$axios.get('/channel/channels', {params: {'country': item.name}}).then(res => {
          if (res.data) {
            for (let channel of res.data) {
              item.children.push({
                type: 'channel',
                country: item.name,
                name: channel,
                children: []
              })
            }
          }
          resolve(res)
        }).catch(err => {
          this.$bus.$emit('msg', err)
          reject(err)
        })
      })
    },
    getChannelTypes(item) {
      return new Promise((resolve, reject) => {
        this.$axios.get('/channel/channelTypes', {
          params: {
            'country': item.country,
            'channel': item.name
          }
        }).then(res => {
          if (res.data) {
            for (let channelType of res.data) {
              item.children.push({
                type: 'channelType',
                country: item.country,
                channel: item.name,
                name: channelType,
                children: []
              })
            }
          }
          resolve(res)
        }).catch(err => {
          this.$bus.$emit('msg', err)
          reject(err)
        })
      })
    },
    getRepositories(item) {
      return new Promise((resolve, reject) => {
        this.$axios.get('/channel/repositories', {
          params: {
            'country': item.country,
            'channel': item.channel,
            'channelType': item.name
          }
        }).then(res => {
          if (res.data) {
            for (let repository of res.data) {
              item.children.push({
                type: 'repository',
                country: item.country,
                channel: item.channel,
                channelType: item.name,
                name: repository,
                parent: item,
                children: []
              })
            }
          }
          resolve(res)
        }).catch(err => {
          this.$bus.$emit('msg', err)
          reject(err)
        })
      })
    },

    getLimits(item) {
      return new Promise((resolve, reject) => {
        this.$axios.get('/channel/limits', {
          params: {
            'country': item.country,
            'channel': item.channel,
            'channelType': item.channelType,
            'repository': item.name,
          }
        }).then(res => {
          if (res.data) {
            for (let limit of res.data) {
              item.children.push({
                type: 'limit',
                country: item.country,
                channel: item.channel,
                channelType: item.channelType,
                repository: item.name,
                priceType: limit.priceType,
                minLimit: limit.minLimit,
                maxLimit: limit.maxLimit,
                name: `${limit.minLimit} - ${limit.maxLimit} ${limit.priceType === 1 ? "KG" : "CBM"}`,
              })
            }
          }
          resolve(res)
        }).catch(err => {
          this.$bus.$emit('msg', err)
          reject(err)
        })
      })
    },
  },
}
</script>

<style scoped>

</style>